import { render, staticRenderFns } from "./assistantRemark.vue?vue&type=template&id=3f6397d7&scoped=true"
import script from "./assistantRemark.vue?vue&type=script&lang=js"
export * from "./assistantRemark.vue?vue&type=script&lang=js"
import style0 from "./assistantRemark.vue?vue&type=style&index=0&id=3f6397d7&prod&lang=less"
import style1 from "./assistantRemark.vue?vue&type=style&index=1&id=3f6397d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6397d7",
  null
  
)

export default component.exports